import { StarShootingIcon } from './StarShootingIcon';

/**
 * author: Colton Wiscombe
 * id 18267D80-A569-4013-84F4-7024F3990F47
 * name star-shooting
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-shooting.svg
 * tags
 */
export const FavoriteShootingIcon = StarShootingIcon;
export default FavoriteShootingIcon